import { client } from './client'
import { parseContentDispositionFilename } from '@/lib/downloadBlob'
import type { ContextSourceListItem, ProviderBranchInfo, UploadContextRepositoriesRequest, UploadContextRepositoriesResponse, UploadContextWikiPagesRequest, UploadContextWikiPagesResponse, PaginationParams, PagedResult, ContextSourceFilters } from '@/types'

export const contextSourcesApi = {
  getAll: (projectId: string, params?: Partial<PaginationParams> & ContextSourceFilters) =>
    client.get<PagedResult<ContextSourceListItem>>(`/projects/${projectId}/context-sources`, { params }).then(r => r.data),

  uploadFiles: (projectId: string, data: FormData) =>
    client.post(`/projects/${projectId}/context-sources/files`, data, {
      headers: { 'Content-Type': undefined },
    }).then(r => r.data),

  uploadRepositories: (projectId: string, request: UploadContextRepositoriesRequest) =>
    client.post<UploadContextRepositoriesResponse>(`/projects/${projectId}/context-sources/repositories`, request).then(r => r.data),

  uploadWikiPages: (projectId: string, request: UploadContextWikiPagesRequest) =>
    client.post<UploadContextWikiPagesResponse>(`/projects/${projectId}/context-sources/wiki-pages`, request).then(r => r.data),

  delete: (projectId: string, id: string) =>
    client.delete(`/projects/${projectId}/context-sources/${id}`).then(r => r.data),

  listBranches: (projectId: string, contextSourceId: string, search?: string) =>
    client.get<ProviderBranchInfo[]>(`/projects/${projectId}/context-sources/${contextSourceId}/branches`,
      { params: search ? { search } : undefined }).then(r => r.data),

  download: async (projectId: string, id: string): Promise<{ blob: Blob; fileName: string }> => {
    const response = await client.get<Blob>(
      `/projects/${projectId}/context-sources/${id}/download`,
      { responseType: 'blob' },
    )
    const fileName = parseContentDispositionFilename(
      response.headers['content-disposition'] as string | undefined,
      'context-source',
    )
    return { blob: response.data, fileName }
  },

  getContent: (projectId: string, id: string) =>
    client.get<{ content: string }>(`/projects/${projectId}/context-sources/${id}/content`).then(r => r.data),

  updateContent: (projectId: string, id: string, content: string) =>
    client.put(`/projects/${projectId}/context-sources/${id}/content`, { content }).then(r => r.data),
}
